import { MoreVertical } from "react-feather";
import { ActionMenu } from "@/Components/ActionMenu";
import React, { useRef } from "react";
import { Inertia } from "@inertiajs/inertia";
import ShrinkableTagRow from "@/Components/ShrinkableTagRow";
import classNames from "classnames";

const SuperuserQuestionRow = ({
  question,
  onDelete = (_) => null,
  onAttach = (_) => null,
  isNew = false,
}) => {
  const actionMenuItems = [];

  if (question.is_published) {
    actionMenuItems.push({
      label: "Add to organization",
      callback: () => onAttach(question.id),
    });
  }

  actionMenuItems.push(
    {
      label: "Edit activity",
      callback: () =>
        Inertia.visit(route("admin.question.edit", { question: question.id })),
    },
    {
      label: "Delete activity",
      callback: () => onDelete(question.id),
    },
  );

  const actionMenuRef = useRef(null);

  return (
    <>
      <div
        className={`shadow-small grid min-h-[53px] grid-cols-4 gap-2 bg-white p-8 transition-shadow md:grid-flow-col-dense md:grid-cols-12 md:py-2 md:pl-12 md:pr-4  ${
          isNew ? "slide-in-top-fade-bg-green" : ""
        }`}
      >
        <div className="col-span-3 flex items-center md:col-span-8">
          <h3
            className={classNames("truncate leading-none", {
              "font-bold ": question.is_published,
            })}
            title={question.title || "(Untitled)"}
          >
            {question.title || "(Untitled)"}
            {!question.is_published && <span> - Draft</span>}
          </h3>
        </div>
        <ShrinkableTagRow tags={question.tags} />
        <button
          className="col-span-1 flex items-center justify-end md:order-last md:col-span-1"
          onClick={(e) => {
            e.preventDefault();
            actionMenuRef.current.toggleMenu();
          }}
        >
          <div className="hover-circle relative z-10 ml-2">
            <MoreVertical size={24} className="shrink-0 cursor-pointer" />
            <ActionMenu ref={actionMenuRef} items={actionMenuItems} />
          </div>
        </button>
      </div>
    </>
  );
};

export default SuperuserQuestionRow;
